import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SERVIZIO_AGGIUNTIVO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolServizioAggiuntivoState extends EntityState<IID_OL_SERVIZIO_AGGIUNTIVO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_SERVIZIO_AGGIUNTIVO })
@InterfaceDataStore(InterfaceName.SERVIZIO_AGGIUNTIVO)
export class IIDolServizioAggiuntivoStore extends EntityStore<IIDolServizioAggiuntivoState> {
  constructor() {
    super([]);
  }
}
